<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
========================================================================================== -->

<template>
    <div class="h-screen flex w-full bg-img" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-1/4 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row lab-photo">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-2/5 mx-auto self-center">
                            <img src="@/assets/images/logo/logo.png" alt="login" class="mx-auto">
                            <h4 style="margin-top:18px; text-align:center; font-weight: bold; color: rgb(97, 60, 206); cursor: default;">DELTA</h4>
                            <center>
                            <vs-button style="margin-top:20px" color="success" @click="update_app">Update</vs-button>
                            </center>
                            <h6 style="margin-top:18px; text-align:center; color: rgb(97, 60, 206); cursor: default;">
                            Version: {{VERSION_DATE}}
                            </h6>
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-3/5 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                </div>
                                <vs-input
                                    v-validate="'required|email|min:3'"
                                    data-vv-validate-on="blur"
                                    name="email"
                                    icon="icon icon-user"
                                    icon-pack="feather"
                                    label-placeholder="Email"
                                    v-model="email"
                                    class="w-full no-icon-border"/>
                                <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                                <vs-input
                                    data-vv-validate-on="blur"
                                    v-validate="'required|min:4|max:15'"
                                    type="password"
                                    name="password"
                                    icon="icon icon-lock"
                                    icon-pack="feather"
                                    label-placeholder="Password"
                                    v-model="password"
                                    class="w-full mt-6 no-icon-border" />
                                <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                <div class="flex flex-wrap py-5">
                                  <vs-button :disabled="!validateForm" @click="login">Login</vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import { VERSION_DATE } from '@/config/config';

export default {
    data() {
        return {
            email: null,
            password: null,
            checkbox_remember_me: false,
            VERSION_DATE: VERSION_DATE
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any() && this.email != '' && this.password != '';
        },
    },
    methods: {
        /*
        login() {
            const payload = {
                checkbox_remember_me: this.checkbox_remember_me,
                userDetails: {
                    email: this.email,
                    password: this.password
                },
                notify: this.$vs.notify
            }
            this.$store.dispatch('auth/loginAttempt', payload);
        },
        */
        login() {
          const payload = {
            email: this.email,
            pass: this.password,
            notify: this.$vs.notify
          };

          this.$store.dispatch('authentication/login', payload);
        },
        update_app() {
          const thisDate = new Date();
          const thisDateString = thisDate.getFullYear().toString() + '-' +
            thisDate.getMonth().toString() + '-' +
            thisDate.getUTCDate().toString();
          // console.log('THIS DATE:');
          // console.log(thisDateString);
          this.$router.go('/?refresh='+ thisDateString);
        },

        notifyAlreadyLogedIn() {
            this.$vs.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
        },
        registerUser() {
            if(this.$store.state.auth.isUserLoggedIn()) {
                this.notifyAlreadyLogedIn();
                return false;
            }
            this.$router.push('/pages/register');
        }
    }
}
</script>

<style lang="scss">
.lab-photo {
  background-color: #fff;
}
#page-login.bg-img {
  background-image: none;
  background-color: #eee;
}
</style>
